/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import types */
import type {
    TimeSeriesCalc,
    TimeSeriesTrafficLightConfig,
} from '@/lib/timeSeries/timeSeriesValue';

export type SystemDashboardKpiStatusValues = Readonly<Record<string, number | null | undefined>>;

export interface SystemDashboardKpiStatusDefinition {
    calc: TimeSeriesCalc;
    calcCode?: string;
    sourceSensorTypes: readonly string[];
    trafficLight: TimeSeriesTrafficLightConfig;
}

function normalizeStatusValues(
    values: SystemDashboardKpiStatusValues,
): Record<string, number | null> {
    return Object.fromEntries(
        Object.entries(values).map(([sensorType, value]) => [sensorType, value ?? null]),
    );
}

/**
 * Applies the executable KPI calculation. All definitions return the shared
 * numeric status scale: -1 implausible, 0 OK, 1 warning, 2 error.
 */
export function calculateSystemDashboardKpiStatus(
    definition: SystemDashboardKpiStatusDefinition,
    values: SystemDashboardKpiStatusValues,
): number {
    return definition.calc({ values: normalizeStatusValues(values) }).status ?? -1;
}
